import React from 'react';
import { Modal } from 'react-bootstrap';
import { CustomButton } from '../../_common/CustomButton/CustomButton';
import './UpdateDriverConfirmationModal.scss';

interface ModalProps {
    show: boolean;
    loadId: string | null | undefined;
    modalType: string | null | undefined;
    onCancel: () => void;
}

enum modalTypes {
    Update = 'update',
    Unassign = 'unassign',
    EndShift = 'endShift',
}

const UpdateDriverConfirmationModal = ({ show, modalType, onCancel, loadId }: ModalProps): React.ReactElement => {
    return (
        <Modal
            show={show}
            onHide={onCancel}
            className="UpdateDriverConfirmationModal-Container"
            id="updateDriverInfoModal"
        >
            <Modal.Header className="UpdateDriverConfirmationModal-Header">
                <i className="material-icons UpdateDriverConfirmationModal-CloseIcon" onClick={onCancel}>
                    clear
                </i>
            </Modal.Header>
            <Modal.Body>
                <div className="UpdateDriverConfirmationModal-HeaderText">
                    {modalType === modalTypes.Update
                        ? `This driver is currently on load #${loadId}. This action will update the carrier for the
                        assigned load.`
                        : modalType === modalTypes.Unassign
                        ? `This driver is currently on load #${loadId}. Please deliver the load before you can unassign.`
                        : `This driver is currently on load #${loadId}. Please deliver the load before ending the shift.`}
                </div>
            </Modal.Body>
            <Modal.Footer className="UpdateDriverConfirmationModal-Footer">
                <div className="UpdateDriverConfirmationModal-ButtonContainer">
                    <CustomButton title="Ok" onClick={onCancel} isBordered={false} />
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default UpdateDriverConfirmationModal;

